import React from 'react';
import { connect } from 'react-redux';
import { Divider } from 'semantic-ui-react';
import EntitiesErrorMessages from '@/components/errors/EntitiesErrorMessages';
import fetch from '../hooks/fetch';
import CollectionName from './CollectionName';
import CollectionPanelContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/CollectionPanelContainer';
import CollectionDescription from './CollectionDescription';
import CollectionImage from './CollectionImage';
import CollectionDatasetsPanelNarrow from '../datasets/containers/CollectionDatasetsPanelNarrow';

const CollectionPanelNarrow = ({
  category,
  canRead,
  code,
  exists,
  fetchData,
  isDirty,
  isEditing,
  isNew,
  name,
  onChange,
  readErrors,
  readStatus,
  saveErrors,
  updateProperties,
  url,
}) => {
  fetch.useFetchCollection(fetchData, category, code, readStatus, isNew);
  return (
    <CollectionPanelContainer
      canRead={canRead}
      exists={exists}
      isDirty={isDirty}
      isNew={isNew}
      name={name}
      onChange={onChange}
      readErrors={readErrors}
      readStatus={[readStatus]}
      url={url}
    >
      <div className="aridhia-collection-panel-narrow overflow-x-hidden">
        <EntitiesErrorMessages
          category={category}
          code={code}
          entity="collection"
          errors={saveErrors}
          onDismiss={(errors) => updateProperties(category, code, { saveErrors: errors })}
        />
        <CollectionName code={code} category={category} />
        <CollectionImage code={code} category={category} narrowView />
        <CollectionDescription code={code} category={category} />
        {!isEditing
        && (
        <>
          <Divider />
          <CollectionDatasetsPanelNarrow category={category} code={code} />
        </>
        )}
      </div>
    </CollectionPanelContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CollectionPanelNarrow);
